import { useContext } from "react";
import { LoaderContext } from "../loaderProvider";

// Hook personnalisé pour utiliser le contexte
export const useLoader = () => {
  const context = useContext(LoaderContext);
  if (!context) {
    throw new Error('useLoader doit être utilisé à l\'intérieur d\'un LoaderProvider');
  }
  return context;
};

